<template>
  <div 
    class="div_login"
    :class="{ 'is-desktop': isDesktop }"
  >
    <div v-if="!isDesktop" class="header">
      <!-- <div class="logo flex">
        <img class="cp_us" @click="router.push('/')" :src="logo" draggable="false" alt="">
      </div> -->
      <div @click="router.push('/')" class="logo_box flex cp_us">
        <img
          class="logo_img"
          draggable="false"
          ondragstart="return false;"
          :src="images.conbrieLogo"
          alt=""
        />
      </div>
      <el-button class="backHome" @click="goBackHome()">返回首页</el-button>
    </div>
    <div class="login_content flex_center">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import "./login.scss";
import store from "@/store";
import { useRouter } from "vue-router";

const images = {
  conbrieLogo: require("@/assets/images/global/conbrie-logo.png")
}
let isDesktop = ref(false);
const router = useRouter();

onMounted(()=>{
  if(window.keymemoApi){
    isDesktop.value = window.keymemoApi.getEquipment() ? true : false
  }
})

function goBackHome() {
  localStorage.clear();
  let pushUrl = process.env.VUE_APP_REDIRECT;
  if(store.state.source){
    let source = store.state.source;
    let result = source.replace(process.env.VUE_APP_REDIRECT, '');
    if(result.startsWith('community')){
      pushUrl = pushUrl + 'community';
    }
  }
  window.location.replace(pushUrl);
}
</script>

<style lang='scss' scoped>
.div_login {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  overflow: auto;
  .header {
    height: 60px;
    padding: 0 35px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .logo_box{
      height: 50px;
      .logo_img {
        height: 40px;
      }
    }
    .backHome {
      width: 128px;
      height: 50px;
      background: #ffffff;
      border-radius: 15px 15px 15px 15px;
      border: 4px solid #f4f4f4;
      box-sizing: border-box;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
    }
  }
  .login_content {
    height: calc(100% - 60px);
    min-height: 620px;
  }
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
.is-desktop{
  .header{
    display: none;
  }
  .login_content {
    height: 100%;
  }
}
@media screen and (max-width: 768px) {
  .div_login {
    .header {
      height: 0.5rem;
      padding: 0 0.2rem;
      .logo_box{
        height: 0.4rem;
        .logo_img {
          height: 0.25rem;
        }
      }
      .backHome {
        width: 1rem;
        height: 0.4rem;
        border-radius: 0.1rem;
        border: 0.02rem solid #f4f4f4;
        font-size: 0.14rem;
      }
    }
    .login_content {
      height: calc(100% - 0.5rem);
      min-height: auto;
    }
  }
  .is-desktop{
    .login_content{
      height: 100%;
    }
  }
}
</style>
